import React, { FC } from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

const indetPhased = keyframes`
  0% {
    clip-path: inset(0 100% 0 0);
    -webkit-clip-path: inset(0 100% 0 0);
    animation-timing-function: cubic-bezier(0.2, 0, 0, 1);
  }
  66.666% {
    clip-path: inset(0 20% 0 0);
    -webkit-clip-path: inset(0 20% 0 0);
    animation-timing-function: cubic-bezier(.2,0,0,1);
  }
  83.333% {
    clip-path: inset(0 0 0 0);
    -webkit-clip-path: inset(0 0 0 0);
    animation-timing-function: linear;
  }
  100% {
    clip-path: inset(0 0 0 100%);
    -webkit-clip-path: inset(0 0 0 100%);
  }
`;

interface Props {
  visible?: boolean;
  brandColor?: string;
}

export const SpeedBar: FC<Props> = ({ visible = true, brandColor }) => {
  if (!visible) return null;
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        background: brandColor ? `${brandColor}24` : 'rgba(47,79,79,.14)',
        zIndex: 1500,
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: brandColor || 'rgba(47,79,79,.92)',
          borderRadius: '999px',
          willChange: 'clip-path, -webkit-clip-path',
          animation: `${indetPhased} 650ms infinite`,
        },
      }}
    />
  );
};
